/* TODO(strata): remove once the suite-by-id API returns `propertyName`.
 *
 * Why this exists (API gap, hacky but it is what it is): the suite payload comes back
 * with `propertyName: null`, AND the shared Service Request table drops the property
 * name from nav state when a request is opened (it only forwards { navigateTo, navLabel }).
 * So the Strata Manager sidebar breadcrumb loses its "Property" node the moment you drill
 * into an SR, and can't restore it when navigating back up to the suite.
 *
 * Stopgap: stash the property name by suiteId (captured from the landing's nav state) in
 * sessionStorage, and recall it on the SR / back-nav routes. Contained to the SM sidebar,
 * survives refresh, and `setItem` overrides an existing entry so a re-visit keeps it fresh.
 * Delete this whole module when the suite payload includes propertyName. */

const keyFor = (suiteId: string): string => `strata-prop-name:${suiteId}`;

export const rememberPropertyName = (
  suiteId: string,
  propertyName: string
): void => {
  if (!suiteId || !propertyName) {
    return;
  }

  sessionStorage.setItem(keyFor(suiteId), propertyName);
};

export const recallPropertyName = (suiteId: string): string | null => {
  if (!suiteId) {
    return null;
  }

  return sessionStorage.getItem(keyFor(suiteId));
};
